module.exports = __webpack_public_path__ + "img/f16c977981a56c6e91ef156ce3819ec1.132bb18a.png";